import s from "./_baseIsArguments.js";
import a from "./isObjectLike.js";
var e = s, o = a, t = Object.prototype, n = t.hasOwnProperty, m = t.propertyIsEnumerable, p = e(function() {
  return arguments;
}()) ? e : function(r) {
  return o(r) && n.call(r, "callee") && !m.call(r, "callee");
}, u = p;
export {
  u as default
};
//# sourceMappingURL=isArguments.js.map
